import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import {Label} from "@/components/ui/label";

interface GuarantorPhoneNumberInputProps {
    value: string;
    onChange: (value: string) => void;
    error?: string;
}

const GuarantorPhoneNumberInput: React.FC<GuarantorPhoneNumberInputProps> = ({
                                                                                 value,
                                                                                 onChange,
                                                                                 error,
                                                                             }) => {
    return (
        <div className="w-full space-y-2">
            <Label>Телефон</Label>

            <div
                className={[
                    "rounded-md border transition-colors",
                    error
                        ? "border-destructive focus-within:ring-1 focus-within:ring-destructive"
                        : "border-input focus-within:ring-1 focus-within:ring-ring",
                ].join(" ")}
            >
                <PhoneInput
                    onlyCountries={["kg", "ru"]}
                    country="kg"
                    value={value || "996"}
                    onChange={(val: string) => onChange(val)}
                    inputProps={{
                        name: "guarantorPhone",
                        required: true,
                        autoComplete: "off",
                    }}
                    containerStyle={{width: "100%"}}
                    inputStyle={{
                        width: "100%",
                        height: "40px",
                        border: "none",
                        paddingLeft: "48px",
                        fontSize: "14px",
                        background: "transparent",
                    }}
                    buttonStyle={{
                        border: "none",
                        background: "transparent",
                    }}
                    dropdownStyle={{
                        zIndex: 50,
                    }}
                    placeholder="Введите номер"
                    specialLabel=""
                />
            </div>

            {error ? (
                <p className="text-xs text-destructive">{error}</p>
            ) : null}
        </div>
    );
};

export default GuarantorPhoneNumberInput;
